import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { BackboneEquipmentFieldComponent } from './backbone-equipment-field.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
  ],
  declarations: [
    BackboneEquipmentFieldComponent,
  ],
  exports: [
    BackboneEquipmentFieldComponent,
  ],
})
export class BackboneEquipmentsExportModule {}
